import React, { MutableRefObject } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import logging from "app/shared/utils/logging";

const disableRecaptcha = process.env.REACT_APP_DISABLE_RECAPTCHA === "true";

interface IGRecaptchaManager {
    recaptchaRef: MutableRefObject<null | ReCAPTCHA>;
    executeAndRetrieveToken(appInsights: ReactPlugin, pageName: string): Promise<null | string>;
}

class GRecaptchaManager implements IGRecaptchaManager {
    recaptchaRef: MutableRefObject<ReCAPTCHA | null> = React.createRef();

    async executeAndRetrieveToken(
        appInsights: ReactPlugin,
        pageName: string,
    ): Promise<string | null> {
        let recaptchaToken = null;
        if (this.recaptchaRef.current) {
            if (!disableRecaptcha) {
                recaptchaToken = await this.recaptchaRef.current?.executeAsync() as string;

                if (recaptchaToken) {
                    logging.info(
                        appInsights,
                        `evt_${pageName}_recaptcha_success`,
                        `${pageName}_RECAPTCHA_TOKEN_GENERATED`,
                        recaptchaToken,
                    );
                } else {
                    logging.error(
                        appInsights,
                        `evt_${pageName}_recaptcha_failed`,
                        `${pageName}_RECAPTCHA_TOKEN_FAILED`,
                    );
                }
            } else {
                logging.info(
                    appInsights,
                    `evt_${pageName}_recaptcha_disabled`,
                    `${pageName}_RECAPTCHA_DISABLED`,
                );
            }
        }

        return recaptchaToken;
    }
}

const gRecaptchaManager = new GRecaptchaManager();

export default gRecaptchaManager;
